
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalUserData from '@/components/templates/manage/ModalUserData.vue'
import { SelectItem } from '@/models/SelectItem'
import PasswordUtils from '@/utils/PasswordUtils'
import { BranchesApi } from '@/api/methods/manage/BranchesApi'
import { UserBranchesApi } from '@/api/methods/manage/UserBranchesApi'
import StringUtils from '@/utils/StringUtils'

/**
 * 先生情報登録モーダル
 */
@Component({
  components: {
    ModalUserData,
  },
})
export default class ModalRegistTeacher extends Vue {
  /** ユーザ情報モーダルのフォーマット */
  @Ref()
  modalUserData!: ModalUserData

  /** 先生更新後の処理 */
  @Prop()
  private afterUpdateTeacher!: () => Promise<void>

  /** 教室プルダウンの固定値「未選択」 */
  private readonly OPTION_NOT_SELECTED = { value: '', label: '未選択' }

  /** 教室一覧 */
  private branchList: SelectItem[] = []

  /** 教室選択の初期値 */
  private defaultBranchCode: string = ''

  /**
   * 送信ボタンのdisabled制御
   *
   * @param nickname ニックネーム
   * @param password パスワード
   * @param confirm 確認用パスワード
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(nickname: string, password: string, confirm: string): boolean {
    // ニックネームが未入力の場合true
    if (StringUtils.isBlank(nickname)) {
      return true
    }

    // パスワードが未入力の場合true
    if (!password) {
      return true
    }

    // 確認用パスワードが未入力の場合true
    if (!confirm) {
      return true
    }

    // 教室が未選択の場合true
    if (this.currentBranch() === this.OPTION_NOT_SELECTED.value || StringUtils.isBlank(this.currentBranch())) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // パスワードのバリデーションチェック
    errorMessage = this.validPassword()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    errorMessage = PasswordUtils.checkPasswordEnabled(this.modalUserData.password)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 先生ユーザ登録
    await UserBranchesApi.createTeacher(
      this.modalUserData.nickname,
      this.modalUserData.password,
      Number(this.currentBranch())
    )

    // 先生更新後の処理
    //   メソッド内で先生一覧の再取得を行う
    await this.afterUpdateTeacher()

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()
  }

  /**
   * 選択中の教室
   *
   * @returns 教室コード(ID)
   */
  private currentBranch(): string {
    return this.modalUserData.selectedValue()
  }

  /**
   * パスワードのバリデーションチェック
   *
   * @returns 確認用パスワードと一致しない場合はエラーメッセージを返す
   */
  private validPassword(): string | null {
    if (this.modalUserData.password !== this.modalUserData.confirm) {
      return 'パスワードと確認用パスワードが一致しません'
    }

    return null
  }

  /**
   * モーダルを開く
   */
  public async show(): Promise<void> {
    this.$loading.start()

    // 教室一覧取得
    const branches = await BranchesApi.getBranches()

    // 教室プルダウン設定
    this.branchList = branches.map((branch) => {
      return {
        // 教室IDをコードとして使用
        value: String(branch.id),
        label: branch.name,
      }
    })

    // 教室プルダウンの先頭に「未選択」を設定
    this.branchList.unshift(this.OPTION_NOT_SELECTED)

    // 教室プルダウンの初期値を設定
    this.defaultBranchCode = this.branchList[0].value

    // モーダルを開く
    this.modalUserData.show()

    this.$loading.complete()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalUserData.hide()
  }
}
